"use client";

import { Card, CardContent, CardHeader } from "@heroui/react";
import clsx from "clsx";
import { ReactNode } from "react";

import { Line, Title } from "@/features/common/components/section-heading";

interface Props {
  className?: string;
  icon: ReactNode;
  title: string;
  description: string;
}

export default function PathCardInfo({
  className,
  icon,
  title,
  description,
}: Props) {
  return (
    <Card
      className={clsx(
        "group bg-primary-100 dark:bg-secondary relative h-80 overflow-hidden rounded-2xl shadow-sm transition-all duration-300 ease-out hover:-translate-y-1 hover:shadow-xl md:h-90",
        className,
      )}
    >
      <div className="to-primary-200/30 pointer-events-none absolute inset-0 bg-linear-to-br from-white/40 via-transparent opacity-80 transition-opacity duration-300 group-hover:opacity-100 dark:from-white/10 dark:to-slate-900/40" />

      <CardHeader className="z-10 flex items-start justify-start px-4 pt-4 pb-2">
        {icon}
      </CardHeader>
      <CardContent className="z-10 flex h-full flex-col px-4 pt-1 pb-4 text-start">
        <Title className="text-primary-700 line-clamp-2 w-full text-lg leading-tight font-semibold md:text-xl dark:text-slate-100">
          {title}
        </Title>
        <Line className="bg-primary-400 my-3 h-0.5 dark:bg-slate-500" />
        <p className="line-clamp-4 text-xs leading-7 text-slate-600 md:text-xs dark:text-slate-200">
          {description}
        </p>
      </CardContent>
    </Card>
  );
}

{
  /* <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-red-100">
  <CreditCard className="h-6 w-6 text-red-500" />
</div>; */
}
